import { Component, inject } from '@angular/core';
import { BaryTableDataEnum } from 'models/enums/bary-table.enum';
import { QuotationService } from '../../../../services/quotation.service';

@Component({
  selector: 'jhi-my-quotations-new',
  templateUrl: './my-quotations-new.component.html',
  styleUrls: ['../my-quotations-tab.component.scss'],
})
export class MyQuotationsNewComponent {
  protected readonly quotationsService = inject(QuotationService);
  protected readonly QUOTES = BaryTableDataEnum.QUOTES;
}
